import styled from "styled-components";
import { responsive } from "../mixins";

export const Wrapper = styled.section`
  ${responsive.tablet.standard`
   margin-bottom: 7rem; 
`}
`;

export const Container = styled.div`
  min-height: calc(100vh - var(--nav-height));
`;
